<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="培训报名" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
                <a-button :loading="saving || loading" @click="onPrint">打印</a-button>
            </template>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="培训报名">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名表编号">
                                            <a-input ref="bmsqbbh" v-model="editData.bmsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名日期" required>
                                            <a-date-picker ref="bmrq" v-model="editData.bmrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名单位编号">
                                            <a-input ref="bmdwbh" v-model="editData.bmdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名单位名称">
                                            <FGDictSelectCN ref="bmdwmc" dictNo="RY100101" v-model="editData.bmdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="班级名称" required>
                                            <a-input-search ref="bjmc" readOnly @search="isShow_bjmc = true" v-model="editData.bjmc" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_bjmc"
                                                selectNo="JC1008"
                                                :condition="selStaticCondition1"
                                                @saveselect="saveEvent_bjmc(arguments, editData)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="班级类别">
                                            <a-input ref="bjlb" v-model="editData.bjlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="班级人数">
                                            <a-input ref="bjrs" v-model="editData.bjrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名人数">
                                            <a-input ref="bmrs" v-model="editData.bmrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名开始日期">
                                            <a-input ref="ksrq" v-model="editData.ksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名结束日期">
                                            <a-input ref="jsrq" v-model="editData.jsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="培训开始日期">
                                            <a-input ref="pxksrq" v-model="editData.pxksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="培训结束日期">
                                            <a-input ref="pxjsrq" v-model="editData.pxjsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="培训内容">
                                            <a-input ref="pxnr" v-model="editData.pxnr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="培训地点">
                                            <a-input ref="pxdd" v-model="editData.pxdd" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系电话">
                                            <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="纳税人识别号" required>
                                            <a-input ref="nsrsbh" v-model="editData.nsrsbh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开票地址" required>
                                            <a-input ref="kpdz" v-model="editData.kpdz" required />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="开票电话" required>
                                            <a-input ref="kpdh" v-model="editData.kpdh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开户行" required>
                                            <a-input ref="khh" v-model="editData.khh" required />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="开户行账号" required>
                                            <a-input ref="khzh" v-model="editData.khzh" required />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="备注">
                                            <a-input ref="bz" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="报名申请表明细">
                                <!-- 表格 -->
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertItem">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable>
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="xm"
                                        title="姓名"
                                        header-class-name="required"
                                        align="center"
                                        :edit-render="{ type: 'default', autofocus: 'input' }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input-search ref="xm" readOnly @search="searchByXM(scope.row)" v-model="scope.row.xm" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="xb"
                                        title="性别"
                                        header-class-name="required"
                                        align="center"
                                        width="90px"
                                        :edit-render="{ type: 'default', autofocus: 'input' }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="scope.row.xb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zjhm" title="证件号码" width="150" sortable align="center"></vxe-table-column>
                                    <vxe-table-column
                                        field="rylb"
                                        title="人员类别"
                                        header-class-name="required"
                                        align="center"
                                        :edit-render="{ type: 'default', autofocus: 'input' }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="scope.row.rylb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="ssdwmc" title="所属单位名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zcdwmc" title="登记单位名称" align="center"></vxe-table-column>
                                    <vxe-table-column
                                        field="lxdh"
                                        title="联系电话"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{ type: 'default', autofocus: 'input' }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.lxdh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="xxdz" title="详细地址" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xxdz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="yzbm" title="邮政编码" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.yzbm" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="sfzs" title="是否住宿" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="sfzs" dictNo="1101" v-model="scope.row.sfzs" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zsyq" title="住宿要求" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zsyq" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="jhrdsj" title="计划入店时间" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhrdsj" v-model="scope.row.jhrdsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="jhldsj" title="计划离店时间" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhldsj" v-model="scope.row.jhldsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zczt" title="登记状态" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="scope.row.zczt" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column title="操作" width="70" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 操作日志 -->
                        <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
            <FGDataSelect
                :isShow.sync="isShow_xm"
                selectNo="RY1001"
                :condition="selStaticCondition"
                @saveselect="saveEvent_xm(arguments, editData)"
            ></FGDataSelect>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "PxbmEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemData: [],
            editItemDataLoading: false,
            selStaticCondition: "",
            selStaticCondition1: " AND ZT='报名'",
            isShow_bjmc: false,
            isShow_xm: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken", "getNoticeId"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "RY_BMSQB",
                fkfield: "ID",
                attachsource: "RY5000",
                fkvalue: this.editData.id
            };
        }
    },
    created() {},
    activated() {
        this.selStaticCondition = " AND SSDWID='" + this.getUserInfo.companyInfo.id + "' ";
        if (!this.editDataId) {
            this.editItemData = [];
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                bmrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                bmsqbbh: "",
                djlxid: "BMSQB",
                zjlx: "身份证",
                zczq: 3,
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                bmdwid: this.getUserInfo.companyInfo.id,
                bmdwbh: this.getUserInfo.companyInfo.dwbh,
                bmdwmc: this.getUserInfo.companyInfo.dwmc,
                lrbmmc: this.getUserInfo.org_name,
                lrrxm: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                djzt: "制定",
                bjmc: "",
                nsrsbh: this.getUserInfo.companyInfo.nsrsbh,
                kpdz: this.getUserInfo.companyInfo.kpdz,
                kpdh: this.getUserInfo.companyInfo.kpdh,
                khh: this.getUserInfo.companyInfo.khh,
                khzh: this.getUserInfo.companyInfo.khzh
            };
            this.$FG_helper.handleNewBillCode("BMSQBBH").then((val) => {
                this.editData.bmsqbbh = val;
            });

            if (this.getNoticeId) {
                this.$FG_http
                    .post(
                        "./api/main/jcsj/pxbj/selectById",
                        {
                            id: this.getNoticeId
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data, errMsg }) => {
                        if (success && data.data) {
                            this.editData.bjid = data.data.id;
                            this.editData.bjmc = data.data.bjmc;
                            this.editData.bjlb = data.data.bjlb;
                            this.editData.bjrs = data.data.bjrs;
                            this.editData.bmrs = data.data.bmrs;
                            this.editData.ksrq = data.data.ksrq;
                            this.editData.jsrq = data.data.jsrq;
                            this.editData.pxksrq = data.data.pxksrq;
                            this.editData.pxjsrq = data.data.pxjsrq;
                            this.editData.pxnr = data.data.pxnr;
                            this.editData.pxdd = data.data.pxdd;
                            this.editData.lxr = data.data.lxr;
                            this.editData.lxdh = data.data.lxdh;
                            this.setNoticeId(null);
                        }
                    });
            }
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.bmsqbbh.focus();
        });
    },
    methods: {
        ...mapActions(["setNoticeId"]),
        searchByXM(row) {
            this.isShow_xm = true;
            this.selectItem = row;
        },
        saveEvent_xm(val, currentrow) {
            if (val && val.length > 0) {
                this.selectItem.jsryid = val[0][0].ID;
                this.selectItem.xm = val[0][0].XM;
                this.selectItem.xb = val[0][0].XB;
                this.selectItem.rylb = val[0][0].RYLB;
                this.selectItem.bmrs = val[0][0].BMRS;
                this.selectItem.ssdwid = val[0][0].SSDWID;
                this.selectItem.ssdwmc = val[0][0].SSDWMC;
                this.selectItem.zcdwid = val[0][0].ZCDWID;
                this.selectItem.zcdwmc = val[0][0].ZCDWMC;
                this.selectItem.lxdh = val[0][0].LXDH;
                this.selectItem.xxdz = val[0][0].XXDZ;
                this.selectItem.yzbm = val[0][0].YZBM;
                this.selectItem.zjhm = val[0][0].ZJHM;
            }
        },
        saveEvent_bjmc(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.bjid = val[0][0].ID;
                this.editData.bjmc = val[0][0].BJMC;
                this.editData.bjlb = val[0][0].BJLB;
                this.editData.bjrs = val[0][0].BJRS;
                this.editData.bmrs = val[0][0].BMRS;
                this.editData.ksrq = val[0][0].KSRQ;
                this.editData.jsrq = val[0][0].JSRQ;
                this.editData.pxksrq = val[0][0].PXKSRQ;
                this.editData.pxjsrq = val[0][0].PXJSRQ;
                this.editData.pxnr = val[0][0].PXNR;
                this.editData.pxdd = val[0][0].PXDD;
                this.editData.lxr = val[0][0].LXR;
                this.editData.lxdh = val[0][0].LXDH;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxbm/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.loadItemData();
                            this.initOperLog();
                            this.selStaticCondition = " AND SSDWID='" + this.getUserInfo.companyInfo.id + "' ";
                            this.selStaticCondition1 =
                                " AND ZT='报名' AND KSRQ<='" +
                                this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss") +
                                "' AND JSRQ>='" +
                                this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss") +
                                "' ";
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxbm/listItem",
                    {
                        id: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增明细
        insertItem() {
            let xh = this.$refs.itemTable.getTableData().tableData.length + 1;
            // 设置编辑记录
            this.$refs.itemTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        bmsqbid: this.editData.id,
                        xh: xh,
                        sfjf: "否"
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemTable.setActiveRow(row);
                });
        },
        //打印
        onPrint() {
            this.$FG_http
                .post(
                    "./api/main/report/generateReport",
                    {
                        ID: this.editData.id,
                        rptid: "BMSQBMX"
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(url);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        // 删除明细
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/jsry/pxbm/deleteMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemData();
                                }
                            });
                    }
                }
            });
        },
        //提交form
        onSave(btnType) {
            if (!this.editData.bmrq) {
                this.$FG_message.error("P0001", "报名日期").then(() => this.$refs.bmrq.focus());
                return;
            }
            if (!this.editData.bjmc) {
                this.$FG_message.error("P0001", "班级名称").then(() => this.$refs.bjmc.focus());
                return;
            }
            if (!this.editData.nsrsbh) {
                this.$FG_message.error("P0001", "纳税人识别号").then(() => this.$refs.nsrsbh.focus());
                return;
            }
            if (!this.editData.kpdz) {
                this.$FG_message.error("P0001", "开票地址").then(() => this.$refs.kpdz.focus());
                return;
            }
            if (!this.editData.kpdh) {
                this.$FG_message.error("P0001", "开票电话").then(() => this.$refs.kpdh.focus());
                return;
            }
            if (!this.editData.khh) {
                this.$FG_message.error("P0001", "开户行").then(() => this.$refs.khh.focus());
                return;
            }
            if (!this.editData.khzh) {
                this.$FG_message.error("P0001", "开户行账号").then(() => this.$refs.khzh.focus());
                return;
            }
            // 获取数据
            let itemData = this.$refs.itemTable.getInsertRecords().concat(this.$refs.itemTable.getUpdateRecords());
            let itemRemovedData = [];
            for (let i = 0; i < itemData.length; i++) {
                if (!itemData[i].xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.itemTable.setActiveRow(itemData[i]));
                    return;
                }
                if (!itemData[i].xb) {
                    this.$FG_message.error("P0001", "性别").then(() => this.$refs.itemTable.setActiveRow(itemData[i]));
                    return;
                }
                if (!itemData[i].rylb) {
                    this.$FG_message.error("P0001", "人员类别").then(() => this.$refs.itemTable.setActiveRow(itemData[i]));
                    return;
                }
                if (!itemData[i].lxdh) {
                    this.$FG_message.error("P0001", "联系电话").then(() => this.$refs.itemTable.setActiveRow(itemData[i]));
                    return;
                }
            }

            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxbm/save",
                    {
                        data: this.editData,
                        itemData,
                        itemRemovedData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.isnew = false;
                    } else {
                        this.$refs.bmsqbbh.focus();
                    }
                })
                .then(() => {
                    if (this.editDataId) {
                        if (btnType === 1) {
                            this.submit();
                        } else {
                            this.loadData();
                        }
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/pxbm/submitBS", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bmsqbbh.focus();
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
